import { lazy } from 'react';
export const overlays = {
  'DashboardOverlay:NavigationUpdate': lazy(() => import('./nav-overlay'))
};